import { connect } from 'react-redux'
import ChartSlider from './ChartSlider'

import { getActivitiesHistory } from 'store/entities/identity/actions'
import {
  getIdentityPendingGetHistory,
  getIdentityActivitiesHistoryPage,
  getIdentityActivitiesHistoryCount,
  getIdentityActivitiesHistoryLimit,
  getIdentityActivitiesHistoryIsPageFirst,
  getIdentityActivitiesHistoryIsPageLast,
} from 'store/entities/identity/selectors'

const mapStateToProps = state => ({
  pending: getIdentityPendingGetHistory(state),
  page: getIdentityActivitiesHistoryPage(state),
  count: getIdentityActivitiesHistoryCount(state),
  limit: getIdentityActivitiesHistoryLimit(state),
  isFirstPage: getIdentityActivitiesHistoryIsPageFirst(state),
  isLastPage: getIdentityActivitiesHistoryIsPageLast(state),
})

const mapDispatchToProps = {
  getActivitiesHistory,
}

export default connect(mapStateToProps, mapDispatchToProps)(ChartSlider)
